import {createFeatureSelector, createSelector} from "@ngrx/store";
import {AppState} from "../../index";

export const getAppState = createFeatureSelector<AppState>('app');
//CognitoUser
export const getCognitoUser = createSelector(
  getAppState,
  (state: AppState) => state.cognito
);
